import { defineEnv } from 'static-build-env'
const env = defineEnv() as Record<string, unknown>

const envNumber = (value: string | undefined | null, defaultValue: number) => {
  const number = Number(value)
  return Number.isNaN(number) ? defaultValue : number
}
export const ENV = env.ENV || import.meta.env.VITE_ENV || 'local'
export const WEB_SENTRY_DSN = env.WEB_SENTRY_DSN || import.meta.env.VITE_WEB_SENTRY_DSN || ''
export const IOS_SENTRY_DSN = env.IOS_SENTRY_DSN || import.meta.env.VITE_IOS_SENTRY_DSN || ''
export const ANDROID_SENTRY_DSN =
  env.ANDROID_SENTRY_DSN || import.meta.env.VITE_ANDROID_SENTRY_DSN || ''
export const SENTRY_TRACE_SAMPLE_RATE = envNumber(
  env.SENTRY_TRACE_SAMPLE_RATE || import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE,
  0.1
)
export const RELEASE_ID = env.RELEASE_ID || import.meta.env.VITE_RELEASE_ID || ''

// API Configuration
export const API_BASE_URL = env.API_BASE_URL || import.meta.env.VITE_BASE_URL || ''

// Third-party API Keys
export const WEATHER_API_KEY = env.WEATHER_API_KEY || import.meta.env.VITE_WEATHER_API_KEY || ''

// Analytics Configuration
// Default: enabled (true) if not set
export const ENABLE_ANALYTICS =
  env.ENABLE_ANALYTICS !== undefined
    ? env.ENABLE_ANALYTICS === 'true' || env.ENABLE_ANALYTICS === true
    : import.meta.env.VITE_ENABLE_ANALYTICS !== 'false'

// Security & Inactivity Timeout Settings
export const ACTIVITY_THROTTLE_DELAY = envNumber(
  env.ACTIVITY_THROTTLE_DELAY || import.meta.env.VITE_ACTIVITY_THROTTLE_DELAY,
  1000 // 1 second - throttle for activity detection events
)
export const SESSION_CHECK_INTERVAL = envNumber(
  env.SESSION_CHECK_INTERVAL ||
    import.meta.env.VITE_SESSION_CHECK_INTERVAL ||
    env.INACTIVITY_CHECK_INTERVAL ||
    import.meta.env.VITE_INACTIVITY_CHECK_INTERVAL,
  5 * 1000 // 5 seconds - how often to check for max session time and foreground inactivity
)
export const FOREGROUND_INACTIVITY_TIMEOUT = envNumber(
  env.FOREGROUND_INACTIVITY_TIMEOUT || import.meta.env.VITE_FOREGROUND_INACTIVITY_TIMEOUT,
  30 * 60 * 1000 // 30 minutes - user inactivity in foreground (no screen touch)
)
export const BACKGROUND_INACTIVITY_TIMEOUT = envNumber(
  env.BACKGROUND_INACTIVITY_TIMEOUT || import.meta.env.VITE_BACKGROUND_INACTIVITY_TIMEOUT,
  15 * 60 * 1000 // 15 minutes - app in background
)
export const MAX_SESSION_TIME = envNumber(
  env.MAX_SESSION_TIME || import.meta.env.VITE_MAX_SESSION_TIME,
  24 * 60 * 60 * 1000 // 24 hours - absolute session limit
)

// App Store Configuration
export const APP_STORE_ID = (env.APP_STORE_ID ||
  import.meta.env.VITE_APP_STORE_ID ||
  '6449822771') as string

// Token Refresh Configuration
export const TOKEN_REFRESH_LEEWAY_SECONDS = envNumber(
  env.TOKEN_REFRESH_LEEWAY_SECONDS || import.meta.env.VITE_TOKEN_REFRESH_LEEWAY_SECONDS,
  50 // 50 seconds - leeway for token expiration checks to account for clock skew
)

// LocalStorage & Preferences Keys
export const STORAGE_KEYS = {
  // Preferences API keys (for native platforms)
  DEVICE_TOKEN: 'device_token',
  ACCESS_EXP_TS: 'clienia_access_exp_ts',
  SESSION_START: 'sessionStart',
  LAST_ACTIVE: 'lastActive',

  // LocalStorage keys
  LONG_LIVED_TOKEN: 'longLivedToken',
  LANGUAGE: 'lang',
  PRACTITIONER_DATA: 'practitionerData',
  START_LIVE_ACTIVITY_TOKEN: 'start_live_activity_token',
  FCM_TOKEN: 'fcm_token',
  AUTH_TOKEN: 'clienia_auth_token',
  FEATURES: 'features',
} as const
